module.exports = __webpack_public_path__ + "media/images/icons/flags/NP-05d3f285ec6953c622aa8b0de5270916.svg";